// extracted by mini-css-extract-plugin
export default {"about-card":"AboutCard_about-card__o4XRg","heading":"AboutCard_heading__5R2MY","icon":"AboutCard_icon__GLL41"};